




































import { Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator';
import FileDrop from '@/components/common/FileDrop.vue';
import FileItem from '@/components/common/FileItem.vue';
import DropZone from '@/components/common/DropZone.vue';
import { API, Storage } from 'aws-amplify';

import { getModule } from 'vuex-module-decorators';
import Decisions from '@/store/modules/Decisions';
import Modelling from '@/store/modules/Modelling';
import WorkspaceOptions from '@/store/modules/WorkspaceOptions';
import CardTitle from '@/components/common/CardTitle.vue';
import ValueTypes from '@/utils/ValueTypes';

const decisionsModule = getModule(Decisions);
const modellingModule = getModule(Modelling);
const workspaceOptionsModule = getModule(WorkspaceOptions);

@Component({
    components: { DropZone, FileItem, FileDrop, CardTitle },
})
export default class AudioImporter extends Vue {
    private uploadError = null;
    private uploading = false;
    private uploaded = false;
    private dialog = false;
    private file: any = null;
    private objectKey: string | null = null;
    private uploadProgressPercent: number | null = null;
    private AUDIO_TYPES = ValueTypes.AUDIO_TYPES;
    private increment = 0;

    @Emit('passObjectKey')
    private passObjectKey(objectKey: {key: string, type: string, name: string}) {
        return objectKey;
    }

    get decisionId() {
        return decisionsModule.selectedDecisionId;
    }

    private async fileSelected(files: any) {
        // console.log(this.AUDIO_TYPES);
        // console.log(files);
        // console.log('file uploading');
        this.file = files[0];
        if (this.AUDIO_TYPES.findIndex((item: string) => item === this.file.type) !== -1) {
            try {
                this.uploadError = null;
                this.objectKey = await this.uploadFile(this.file);
                this.passObjectKey({ key:this.objectKey, type:this.file.type, name:this.file.name});
                this.dialog = false;
            } catch (e) {
                this.uploadError = e;
            }
        } else {
            this.uploadError = 'Must Upload a Supported Audio File';
            setTimeout(() => {
                this.uploadError = null;
            }, 2000);
        }
        this.increment ++;
        // console.log(this.file);
    }

    private async uploadFile(file: any) {
        const key: string = `audio/${this.decisionId}/${file.name}`;
        this.uploading = true;
        let uploadResponse: any = await Storage.put(key, file, {
            progressCallback: (progress: any) => {
                this.uploadProgressPercent = progress.loaded / progress.total;
            },
        });

        // console.log(uploadResponse);
        this.uploading = false;
        this.uploaded = true;
        return uploadResponse.key;
    }

    private close() {
        this.dialog = false;
        this.file = null;
    }
}
